<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        filter: function(){
            let state = this;
            state.items = [];
            state.errors = [];

            if(state.userType == 'USER-CUSTOMER'){
                $('#spinner').modal('toggle');
                Request.do(state, 'POST', Request.getDefaultHeader(state),state.filters, `${Endpoints.systemUsers.customerUser}`,
                (response)=>{//SUCCESS CALLBACK
                    state.items = response.results[0].paginatedResults;
                    console.log(state.items);
                    $('#spinner').modal('toggle');  
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                });
            }
            else
            if(state.userType == 'USER-COMPANY'){
                if(state.filters.name.length >= 3){
                    $('#spinner').modal('toggle');
                    Request.do(state, 'POST', Request.getDefaultHeader(state), state.filters, `${Endpoints.companies.companyUser}`,
                    (response)=>{//SUCCESS CALLBACK
                        state.items = response.results[0].paginatedResults;
                        console.log(state.items);
                        $('#spinner').modal('toggle');  
                    },
                    (error)=>{//ERROR CALLBACK
                        console.log(error);
                    });
                }
                else
                {  state.errors.push(state.$t('string.msg.name.min.four.caracter')); }
            }
            else
            if(state.userType == null){
                state.errors.push(state.$t('string.msg.filter.search.user.type'));
            }
        },
        
        selectItem: function(item){
            this.$emit('load-item', item);
        },
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;
        },
        getPageNumbers: function(){
            return this.items.length/10;
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
